import BaseUseCase from "../base_use_case.js.jsx";

class XavinRedirectUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/sessions`
    }).then((result) => {
      const { data: { url: url, key: key } } = result;
      return { url, key };
    });
  }
}

const instance = new XavinRedirectUseCase();
export default instance;